import { useState, useEffect, useRef, useMemo, useContext } from "react";
import { useParams } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import SuiTypography from "components/SuiTypography";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";

import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import toast from "react-hot-toast";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";

import Skeleton from "@mui/material/Skeleton";
import UploadGalleryModal from "pages/de/portfolio/components/UploadGalleryModal";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

import ProductCard from "pages/de/portfolio/components/ProductCard";
import AddGalleryCard from "pages/de/portfolio/components/AddGalleryCard";

import api from "services/api";

const Gallery = ({ slot = "gallery_0" }) => {
  const [userData, setUserData] = useState({}); //retrieve user data by give handle
  const [uploadGalleryVisible, setUploadGalleryVisible] = useState(false);
  const [imgsViewerVisible, setImgsViewerVisible] = useState(false);

  const { store } = useContext(StoreContext);
  const account = useContext(AccountContext);

  const params = useParams();
  const handle = params?.handle;

  useEffect(() => {
    handleRefresh();
  }, [handle]);

  let portfolioData = account?.metadata?.portfolio_content || {};
  if (handle) {
    portfolioData = userData?.metadata?.portfolio_content || {};
  }

  const gallery = portfolioData[slot] || [];

  const handleShowEdit = (e) => {
    setUploadGalleryVisible(true);
  };

  const handleRefresh = async () => {
    if (handle) {
      const userProfile = await api.users.retrieve(handle);
      if (userProfile?.data?.user) {
        setUserData(userProfile?.data?.user);
      }
    } else {
      try {
        const mySelf = await account.handleRefresh();
        setUserData(mySelf?.data?.user || {});
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleClickImage = (e, item, index) => {
    e.preventDefault();
    e.stopPropagation();
    let img = item?.img || {};
    if (!img?.type.includes("video")) {
      setImgsViewerVisible(true);
      setImgsViewerCurrent(index);
    }
  };

  return (
    <SuiBox sx={{ px: 2 }}>
      <div className="m-4">
        <div className="my-2 flex justify-between ">
          <SuiTypography variant="h5" fontWeight="medium" textTransform="capitalize">
            Gallery
          </SuiTypography>

          {handle ? null : (
            <Tooltip title={"Edit your gallery"} placement="top">
              <SuiButton variant="gradient" color="dark" onClick={handleShowEdit}>
                Edit gallery
              </SuiButton>
            </Tooltip>
          )}
        </div>
        <SuiBox sx={{ width: "100%" }}>
          <SuiBox display="flex" alignItems="center" gap={1} sx={{ overflowX: "auto" }}>
            {gallery.map((item, index) => {
              return (
                <div style={{ minWidth: 304, maxWidth: 304, height: 380 }}>
                  <ProductCard
                    index={index}
                    product={item}
                    imageOnly={true}
                    handleClick={(e) => handleClickImage(e, item, index)}
                    editable={handle ? false : true}
                    slot="gallery_0"
                    handleRefresh={handleRefresh}
                    handleEdit={handleShowEdit}
                    isOriginalSize
                  />
                </div>
              );
            })}
            {handle ? null : (
              <AddGalleryCard
                sx={{
                  minWidth: 304,
                  maxWidth: 304,
                  height: 380,
                  display: "block",
                  flex: "0 0 auto",
                }}
                handleRefresh={handleRefresh}
                slot="gallery_0"
              />
            )}
            {handle && gallery.length == 0
              ? [0, 1, 2, 3].map((x) => <Skeleton width={"25%"} height={380} />)
              : null}
          </SuiBox>
        </SuiBox>
      </div>

      {uploadGalleryVisible ? (
        <UploadGalleryModal
          handleClose={() => setUploadGalleryVisible(false)}
          visible={uploadGalleryVisible}
          handleRefresh={() => {
            handleRefresh();
          }}
        />
      ) : null}

      {gallery.length > 0 ? (
        <Lightbox
          open={imgsViewerVisible}
          close={() => setImgsViewerVisible(false)}
          slides={gallery.map((p, inx) => ({ src: p?.img?.url, id: inx }))}
          plugins={[Zoom, Download]}
          zoom={{ maxZoomPixelRatio: 3 }}
          index={imgsViewerCurrent}
        />
      ) : null}
    </SuiBox>
  );
};

export default Gallery;
